
import Vue from "vue";
export default Vue.extend({
	props: {
		value: {
			type: String,
			default: ()=>""
		},
		suggestedAddresses: {
			type: Array as ()=>{name:string, value:string}[],
			default: ()=>[]
		}
	},
	computed: {
		selectedValues():string[]{
			return this.value.replaceAll(",", ";").split(";").map(s=>s.toLowerCase().trim());
		},
		suggestions():{name:string, value:string}[]{
			return this.suggestedAddresses.filter(f=>this.selectedValues.indexOf(f.value ? f.value.toLowerCase().trim() : "") == -1);
		}
	},
	methods: {
		emitValue(val:string){
			if (val.startsWith(";")){
				val = val.substring(1);
			}
			this.$emit("input", val.trim());
		},
		onSelect(clickedValue:{name:string, value:string}){
			let value = clickedValue.value;
			let rootEl = this.$refs.rootEl as any;
			if (!rootEl) return;
			let inputEl = rootEl.inputElement as HTMLInputElement;
			if (!inputEl) return;
			let selectionIndex = inputEl.selectionStart || this.value.length-1;
			let val = this.value.replaceAll(",", ";");
			if (this.selectedValues.length == 0){
				this.emitValue(value);
				return;
			}
			if (selectionIndex >= val.length-1) {
				this.emitValue(`${val}; ${value}`);
				return;
			}
			let indexOfFirstSemi = 0;
			let indexOfLastSemi = val.length-1;
			for (let i = 0; i < val.length; i++){
				if (i < selectionIndex && val.charAt(i) == ";") {
					indexOfFirstSemi = i;
				}
				if (i >= selectionIndex && val.charAt(i) == ";"){
					indexOfLastSemi = i;
					break;
				}
			}
			let firstPart = val.substring(0, indexOfFirstSemi);
			let lastPart = val.substring(indexOfLastSemi);
			val = `${firstPart}; ${value}${lastPart}`;
			this.emitValue(val);
		},
		onInput(value:string){
			this.emitValue(value);
		}
	},
});
